import React from 'react'
import logo from '../../../assets/images/inferenz-logo.svg'
import dp from '../../../assets/images/blueDP.jfif'
import { Link, useNavigate } from 'react-router-dom'
import { AiOutlineUserSwitch } from 'react-icons/ai'
import { FiLogOut } from 'react-icons/fi'

export const Header = () => {
  const navigate = useNavigate()

  //logout function
  const logout = () => {
    localStorage.clear()
    navigate('/ADMS')
  }
  return (
    <div className="container">
      <nav className="navbar navbar-expand-lg bg-light">
        <div className="container-fluid">
          <Link to="/dashboard" className="link">
            <img src={logo} height="25" alt="Logo" loading="lazy" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link
                  className="nav-link  mx-3 mt-3"
                  to="/dashboard"
                  id="hrHome"
                >
                  <h6>Home</h6>
                </Link>
              </li>
              {/* <li className="nav-item">
                <Link className="nav-link  mx-3 mt-3" to="/report" id="report">
                  <h6>Report</h6>
                </Link>
              </li> */}
            </ul>

            <ul className="navbar-nav mb-2 mb-lg-0">
              <li className="nav-item dropdown">
                <img
                  src={dp}
                  className="rounded-circle"
                  height="35"
                  alt="Black and White Portrait of a Man"
                  loading="lazy"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                />

                <ul className="dropdown-menu">
                  <Link to="/portal" className="link">
                    <li
                      className="mx-2 d-flex"
                      style={{ cursor: 'pointer', height: '0.8rem' }}
                    >
                      <AiOutlineUserSwitch size={18} />
                      <h6 className="mt-1 mx-1">Switch portal</h6>
                    </li>
                  </Link>
                  <hr />
                  <li
                    data-bs-target="#exampleModal"
                    data-bs-toggle="modal"
                    className="mx-2 d-flex align-items-center"
                    style={{ cursor: 'pointer', height: '0.8rem' }}
                  >
                    <FiLogOut size={15} /> <h6 className="mt-2 mx-2">Logout</h6>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* modal for logout confirmation */}
      <div
        className="modal"
        tabIndex="-1"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Alert</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to Logout from Intranet ?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  logout()
                }}
                data-bs-dismiss="modal"
              >
                Yes
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
